// extracted by mini-css-extract-plugin
export default {"userBiddings":"user-biddings_userBiddings__y8TX7","noBidsWarning":"user-biddings_noBidsWarning__LLQ+F"};